/*! *********************************************************************
 *
 * Copyright 2021 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *************************************************************************
 */
import SatelliteAnalytics from './SatelliteAnalytics';
/**
 * Analytics class to track the navigation and the events done by the user.
 */
var Analytics = /** @class */ (function () {
    function Analytics() {
        this.analytics = new SatelliteAnalytics();
    }
    Analytics.prototype.init = function (options) {
        this.analytics.init(options);
    };
    Analytics.prototype.track = function (trackData) {
        if (!trackData.isValid(this.getTrackDatasRequirements())) {
            console.error("You must provide at least this properties : " + this.getTrackDatasRequirements().join(','));
            return;
        }
        this.analytics.track(trackData);
    };
    Analytics.prototype.event = function (eventName, data) {
        var testEventName = eventName && eventName !== '';
        if (!testEventName) {
            throw new Error('You must provide at least an event name');
        }
        this.analytics.event(eventName, data);
    };
    Analytics.prototype.getTrackDatasRequirements = function () {
        return this.analytics.getTrackDatasRequirements();
    };
    return Analytics;
}());
export default new Analytics();
